import {
  SET_INBOX_LOADING,
  SET_INBOX_MESSAGES,
  SET_INBOX_ERROR,
  SET_SELECTED_INBOX,
  SET_INBOX_LOADING_MORE,
  APPEND_INBOX_MESSAGES,
  SET_INBOX_PAGINATION,
  SET_UNPROCESSED_COUNT,
  SET_INBOX_SEARCH_TERM,
  SET_INBOX_SEARCH_LOADING,
  UPDATE_MESSAGE_IN_STORE
} from '../actions';

const initialState = {
  messages: [],
  loading: false,
  loadingMore: false,
  searchLoading: false,
  error: null,
  selectedInbox: null,
  pagination: null,
  unprocessedCount: 0,
  searchTerm: ''
};

const inboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INBOX_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: action.payload ? null : state.error // Clear error when starting loading
      };

    case SET_INBOX_LOADING_MORE:
      return {
        ...state,
        loadingMore: action.payload
      };

    case SET_INBOX_MESSAGES:
      return {
        ...state,
        messages: action.payload,
        loading: false,
        error: null
      };

    case APPEND_INBOX_MESSAGES:
      return {
        ...state,
        messages: [...state.messages, ...action.payload],
        loadingMore: false,
        error: null
      };

    case SET_INBOX_PAGINATION:
      return {
        ...state,
        pagination: action.payload
      };

    case SET_INBOX_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loadingMore: false
      };

    case SET_SELECTED_INBOX:
      return {
        ...state,
        selectedInbox: action.payload
      };

    case SET_UNPROCESSED_COUNT:
      return {
        ...state,
        unprocessedCount: action.payload
      };

    case SET_INBOX_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload
      };

    case SET_INBOX_SEARCH_LOADING:
      return {
        ...state,
        searchLoading: action.payload
      };

    case UPDATE_MESSAGE_IN_STORE:
      return {
        ...state,
        messages: state.messages.map(message => 
          message.id === action.payload.messageId 
            ? { ...message, ...action.payload.updates }
            : message
        )
      };

    default:
      return state;
  }
};

export default inboxReducer;